import { ICustomer, IVehicle } from 'online-customer-services-ts'
import { Vehicle } from '@/core/vehicle/domain/Vehicle.ts'
import { Workshop } from '@/core/workshop/domain/Workshop.ts'

export const createEmptyWorkshop = (): Workshop => ({
  id: NaN,
  name: '',
  addressPart1: '',
  addressPart2: '',
  startingWorkHour: '07:00',
  endingWorkHour: '16:00',
  schedulerTimeSlot: NaN,
  brands: [],
  latitude: NaN,
  longitude: NaN,
  timeZoneId: '',
  noWorkingWeekDays: [],
  simaId: NaN,
  idInEnterprise: NaN,
  daysOfMarginToRequest: 0,
  phone: '',
  redirectUrl: ''
})

export const createEmptyVehicle = (): Vehicle => ({
  brand: '',
  kilometers: NaN,
  model: '',
  plate: '',
  vin: '',
  brandCode: ''
})

export const createEmptyModifyVehicle = (): IVehicle => {
  return {
    brand: undefined,
    model: undefined,
    plate: undefined,
    vin: undefined,
    kms: undefined,
    brandCode: undefined
  }
}

export const createEmptyModifyCustomer = (): ICustomer => {
  return {
    name: '',
    phone: '',
    mobile: '',
    email: ''
  }
}
